import React from "react"
import {connect} from "react-redux";
import {pollData, salesforcePush} from "../actions/verifActions";
import Loader from "./Loader";

import {toast} from "react-toastify"
import {CardColumns, Col, Row, Table} from "reactstrap";
import {Moment} from "react-moment";
import FileContainer from "./Verification/FileContainer";
import PasswordField from "./Verification/PasswordField";
import Entry from "./Verification/Timeline/Entry";
import Timeline from "./Verification/Timeline";
import Actions from "./Verification/Actions";
import {withRouter} from "react-router-dom";

import errormap from "./Verification/errors"

class Verification extends React.Component {

  componentWillMount() {
    this.interval = null
    this.props.pollData(this.props.verif_id) 
    this.interval = setInterval(()=>this.startPolling(), 1000)
  }

  componentWillReceiveProps(newProps) {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  startPolling() {
    if (this.props.running) {
      this.props.pollData(this.props.verif_id)
    } else {
      return clearInterval(this.interval)
    }
  }

  render() {
    const filetypes = ['set','dev','exe','db','web','sys','archive']

    const {running, error, errors} = this.props

    const {depo_id, depo_file, contract_id, prod_name} = this.props.data
    const {time_started, current_task, status, timeline, data={}} = this.props.data

    const {filescan, virusscan, checksum, protectedarchives} = data
    console.log(data)

    return (
      <div>
        <Row>
          {/* Info cols */}
          <Col xs={4}>
            <h3>Verification info</h3>
            <Table size='sm' bordered striped>
              <tbody>
              {/* TODO: Make this into components */}
              <tr><td>Verif ID</td><td>{this.props.verif_id}</td></tr>
              <tr><td>Time started</td><td>{time_started}</td></tr>
              <tr><td>Current task</td><td>{current_task}</td></tr>
              <tr><td>Status</td><td>{status}</td></tr>
              </tbody>
            </Table>
          </Col>
          <Col xs={4}>
            <h3>Delivery info</h3>
            <Table size='sm' bordered striped>
              <tbody>
              <tr><td>Delivery ID</td><td>{depo_id}</td></tr>
              <tr><td>Contract ID</td><td><a href={`https://escrowalliance.my.salesforce.com/${contract_id}`} target={`_blank`}>{contract_id}</a></td></tr>
              <tr><td>Product Name</td><td>{prod_name || "missing"}</td></tr>
              <tr><td>File</td><td>{depo_file || "missing"}</td></tr>
              </tbody>
            </Table>
          </Col>
          <Col xs="4">
            <h3>Result</h3>
            <b>{status}</b>
            { errors &&
              <div>
                <p>Errors:</p>
                {errors && errors.map(([c, b])=><p>{errormap[c] || c}</p>)}
              </div>
            }
          </Col>

          {/* Actions col */}
          <Col xs={8}>
            <Actions verif_id={this.props.verif_id} protectedarchives={protectedarchives}/>
          </Col>
        </Row>

        <Row>
          <Col xs={6}>
            <Timeline entries={timeline}/>
          </Col>
          <Col xs={6}>
            <Row>
              {/* Virus col */}
              { virusscan &&
              <Col xs={12}>
                <h3>Virusscan info</h3>
                <Table size='sm' bordered striped>
                  <tbody>
                  {/* TODO: Make this into components */}
                  <tr><td>Anti-virus used</td><td>{virusscan.name}</td></tr>
                  <tr><td>Anti-virus version</td><td>{virusscan.version}</td></tr>
                  <tr><td>Zero infected files</td><td>{virusscan.clean && (virusscan.clean===true ? "YES" : "NO")}</td></tr>
                  <tr><td>Result</td><td>{JSON.stringify(virusscan.result)}</td></tr>
                  </tbody>
                </Table>
              </Col>
              }

              {/* Filescan info col */}
              { filescan &&
              <Col xs={12}>
                <h3>Filescan info</h3>
                <Table size='sm' bordered striped>
                  <tbody>
                  <tr><td>Total files</td><td>{filescan.files}</td></tr>
                  <tr><td>Total directories</td><td>{filescan.directories}</td></tr>
                  <tr><td>Total size</td><td>{filescan.size}</td></tr>
                  <tr><td>Total files (Extracted)</td><td>{filescan.files2}</td></tr>
                  <tr><td>Total directories (Extracted)</td><td>{filescan.directories2}</td></tr>
                  <tr><td>Total size (Extracted)</td><td>{filescan.size2}</td></tr>
                  </tbody>
                </Table>
              </Col>
              }

              {/* Checksum info col */}
              { checksum &&
              <Col xs={12}>
                <h3>Checksum info</h3>
                <Table size='sm' bordered striped>
                  <tbody>
                    <tr><td>File</td><td>{checksum.file}</td></tr>
                    <tr><td>MD5</td><td>{checksum.md5}</td></tr>
                    <tr><td>SHA256</td><td>{checksum.sha256}</td></tr>
                  </tbody>
                </Table>
              </Col>
              }
            </Row>
          </Col>
        </Row>

      { this.props.running && <Loader/>}
      { filescan && filescan['all2'] &&
      <Row xs={12}>
        <CardColumns>
          <FileContainer type='all' data={filescan['all2']}/>
          {filetypes.map(type => <FileContainer type={type} data={filescan[type+'2']}/>)}
        </CardColumns>
      </Row>
      }
    </div>
    )
  }
}

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
  pollData: (verifId) => dispatch(pollData(verifId)),
})

const mapStateToProps = (state) => ({
  running: state.verification.running,
  error: state.verification.error,
  data: state.verification.data,
  errors: state.verification.errors,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Verification))



// WEBPACK FOOTER //
// ./src/components/Verification.js